//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Loading from '@/components/views/loading'
import Service from '@/service'
import BlogService from '@/service/blog'
import BusinessService from '@/service/business_building'
import ConsultantService from '@/service/consultant'

import { mapHouseItem, checkBuildingPhoneAuth } from '@/common/utils/map_view_data'

import { UserLog } from '@/_base/log'

import cardMixin from '../mixin/card'

import { DEFAULT_HEADIMG } from '../const'
import { LEVEL_MAP } from '@/constant'
import { getObtain, getTypeName, handleMedals } from './utils'


import Card from './_card'
import LikeShare from './_like_share'
import Billboard from './_billboard'
import Feeds from './_feeds'
import Buiildings from './_buildings'
import WxArticle from './_wx_article/main'
import { App_User } from '@/data/user_info'

import { getPaginationMixin } from '@/common/mixins/pagination'
import { mapFeeds, mapBlogs } from '@/views/house_circles/data_handle'


export default {
    mixins: [
        cardMixin,
        getPaginationMixin({
            loading_name: 'feeds_loading'
        })
    ],
    name: 'CONSULTANT_CARD',
    data () {
        return {
            liking: false,
            loading: true,
            show_share_option: false,
            show_billboard: false,
            consultant: {
                name: '',
                weixin_name: '',
                building_name: '',
                show_times: '',
                last_period_obtained_score: '',
                like_count: ''
            },
            is_consultant: false,
            house: {},
            buildings: [],
            from: '名片',
            ranking_type:'每日精选',
            wx_articles:[],
            force_phone_auth: false,
            building_id: '',
            consultant_id: '',
            current_tag: '',
            total_count: 0
        }
    },
    mounted () {
        Service.init().then(() => {
            this.getPageData()
            App_User.is_consultant().then((is_consultant) => {
                this.is_consultant = is_consultant
            })
        })
        this.getFeeds()
        UserLog.viewConsultant(this.getParams().id)
    },
    onPullDownRefresh () {
        if (!this.loading) {
            this.getPageData()
        }
    },
    methods: {
        onChangeTag(val) {
            this.page = 1
            this.current_tag = val
            this.getData()
        },
        onStick () {
            this.page = 1
            this.getData()
        },
        getParams () {
            let consultant_id = ''
            const { id, scene } = this.$route.query
            if (scene && scene.indexOf('pccb_') === 0) {
                consultant_id = scene.split('_')[1]
            }
            this.consultant_id = id
            return {
                id: id || consultant_id
            }
        },
        showShareOption () {
            this.show_share_option = true
        },
        hideShareOption () {
            this.show_share_option = false
        },
        toggleBillboard () {
            this.show_billboard = !this.show_billboard
        },
        hideShareTip () {
            this.show_shared_tip = false
        },
        getPageData () {
            const { id, from } = this.getParams()
            const param = {}
            if (from) {
                param.from = from
            }
            this.loading = true
            Service.getConsultant(id, param).then((data) => {
                handleMedals(data)
                const excellect_obtain = getObtain(data, 1)
                const perfessional_obtain = getObtain(data, 2)
                const type = LEVEL_MAP[data.level]
                this.getBuildings(data.building_id, data.buildings)
                this.building_id = data.building_id
                this.consultant = {
                    ...data,
                    weixin_headimgurl: data.weixin_headimgurl || DEFAULT_HEADIMG,
                    original_headimgurl: data.original_headimgurl,
                    type,
                    excellect_obtain,
                    perfessional_obtain,
                    show_excellect: data.is_my_card || excellect_obtain,
                    show_perfessional: data.is_my_card || perfessional_obtain,
                    type_name: getTypeName(type),
                }
                setTimeout(() => {
                    this.loading = false
                    this.getData()
                },500)
                this.changeTitle(data.name)

            }).catch(res => {
                if(res === 404) {
                    wx.showToast({
                        title: '置业顾问下架中，请耐心等待恢复~',
                        icon: 'none',
                        duration: 2000
                    })
                    setTimeout(() => {
                        wx.switchTab({
                            url: '/pages/index/main'
                        })
                    }, 1900)
                }
            })
        },
        async getBuildings (building_id, consultant_buildings) {
            const items = await Promise.all(consultant_buildings.map(({ id, usage }) => {
                return usage === '住宅' ? Service.getBuilding(id) : BusinessService.get(id)
            }))
            items.forEach((item) => {
                ['building_ranking', 'common_probability', 'rd_probability'].forEach((key) => {
                    delete item[key]
                })
            })
            items.forEach((house) => {
                house.id = ''
                if (house.current_houses && house.current_houses.length) {
                    house.id = house.current_houses[0].id
                }
                if (house.live_streaming && house.live_streaming.cover_photo_url) {
                    house.cover_photo_url = house.live_streaming.cover_photo_url
                } else if (house.vr_panorama_resource && house.vr_panorama_resource.cover_image_url) {
                    house.cover_photo_url = house.vr_panorama_resource.cover_image_url
                } else if (house.vr_resource && house.vr_resource.vr_photo_url) {
                    house.cover_photo_url = house.vr_resource.vr_photo_url
                } else if (house.video_resource && house.video_resource.photo_url) {
                    house.cover_photo_url = house.video_resource.photo_url
                } else if (house.photos_urls && house.photos_urls.length) {
                    house.cover_photo_url = house.photos_urls[0]
                }
            })
            const buildings = items.map(mapHouseItem)
            if (buildings.length > 1) {
                buildings.some((building, i) => {
                    if (building.building_id === building_id) {
                        this.house = building
                        buildings.splice(i, 1)
                        buildings.unshift(building)
                        return true
                    }
                })
            } else {
                this.house = buildings[0]
            }
            this.force_phone_auth = checkBuildingPhoneAuth(this.house)
            this.buildings = buildings
        },
        getData () {
            const { id } = this.getParams()
            const params = {
                consultant_id: id,
                tag_name: this.current_tag,
                page: this.page
            }
            BlogService.getConsultantFeeds(params)
                .then(({ items, total_count }) => {
                    this.total_count = total_count
                    this.handleData({ items: mapBlogs(items) })
                })
        },
        changeTitle (name) {
            wx.setNavigationBarTitle({
                title: `置业顾问-${name}`
            })
        },
        goHouse () {
            let params = `building_id=${this.consultant.building_id}`
            wx.navigateTo({
                url: `/building/main?${params}`
            })
        },
        async onLikeConsult (liked) {
            const { consultant } = this
            if (this.liking || consultant.is_liked) {
                return
            }
            this.liking = true
            const { id } = this.getParams()
            await ConsultantService.likeConsultant(id)
            consultant.is_liked = liked
            const like_count = liked ? consultant.like_count + 1 : consultant.like_count - 1
            consultant.like_count = like_count < 0 ? 0 : like_count
            this.consultant = consultant
            this.liking = false
        },
        handleItems (id, handler) {
            this.items.some((item, i) => {
                if (item.id === id) {
                    handler(i)
                    return true
                }
            })
        },
        onDeleteFeed (id) {
            this.handleItems(id, (i) => {
                this.$delete(this.items, i)
            })
        },
        onChangeFeed (item) {
            this.handleItems(item.id, (i) => {
                this.$set(this.items, i, item)
            })
        },
        async getFeeds () {
            const options = {
                content_type: 'weixin_article',
                ranking_type:this.ranking_type,
                page: 1,
                per: 3,
            }
            const data = await Service.getFeeds(options)
            if(data.total_count == 0){
                return
            }
            let items = mapFeeds(data.items)
            items.forEach((item) => {
                item.building = mapHouseItem(item.building)
            })
            this.wx_articles = items
        },
        changeArticle(){
            this.ranking_type = '随机'
            this.getFeeds()
        }
    },
    components: {
        Loading,
        Feeds,
        Card,
        Billboard,
        LikeShare,
        Buiildings,
        WxArticle
    }
}
